import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
const badges = ['150 Ready-to-Use Sessions', '7 Complete Volumes', '5 Free Bonuses', 'Applied Anatomy & Sequences', 'Instant Digital Access'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-12 px-4 overflow-hidden bg-cream" data-id="element-144" data-mp="1297c23jh2z9b">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-145" data-mp="1274kvg6l3030">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-146" data-mp="x8b9btauxj5h">
          <p className="inline-block px-3 py-1 rounded-full border border-terracotta/30 bg-sand text-terracotta-deep font-semibold text-[10px] sm:text-sm tracking-[0.18em] uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-147" data-mp="3cz5weevm861x">
            Massage Therapist Ready
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-charcoal" data-id="element-148" data-mp="3o73ouahgps7j">
            Solve an entire year of{' '}
            <span className="text-terracotta" data-id="element-149" data-mp="3e8efj63mtg2w">massage sessions</span> in just 5
            minutes.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-xl md:max-w-3xl mb-4 sm:mb-6" data-id="element-150" data-mp="30gq5d8cy11ok">
          <img src="https://cdn.magicpatterns.com/uploads/5XjVN25MSbqMpBceYYtNz4/Diseno_sin_titulo_(65).png" alt="Massage Therapist Ready — seven professional volumes, session finder and five bonus guides" className="relative z-10 w-full h-auto" data-id="element-151" data-mp="2hl9puyqujubm" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-152" data-mp="ic87ve5ce4xb">
          <p className="text-sm sm:text-lg md:text-xl text-charcoal-soft leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-153" data-mp="162ugb6j9dr7u">
            The complete professional massage therapy system with 150
            ready-to-use sessions, applied anatomy, technique sequences, client
            adaptations, and 5 exclusive bonus guides—ready to open and use
            today.
          </p>

          <ul className="flex flex-wrap justify-center gap-2 mb-6 sm:mb-7" data-id="element-154" data-mp="3hqu083qvfvy0">
            {badges.map(badge => <li key={badge} className="bg-terracotta-deep text-paper text-[10px] sm:text-xs font-semibold uppercase tracking-wider rounded-full px-3 py-1.5" data-id="element-155" data-mp="1xacfx49qzltr">
                {badge}
              </li>)}
          </ul>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-156" data-mp="2b195sncahox4">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-157" data-mp="2b2soslpbye2l">
              GET MASSAGE THERAPIST READY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal-muted" data-id="element-158" data-mp="2tzbokke8upmh">
            <div className="flex items-center gap-1.5" data-id="element-159" data-mp="un99rngkejf5">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-160" data-mp="uou3xbyyw0ch" />
              <span data-id="element-161" data-mp="4akx2ytnmkfz">7 complete volumes</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-162" data-mp="3vhp5ny5g6eqi">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-163" data-mp="3vh5lsbw8lg9u" />
              <span data-id="element-164" data-mp="9ah1v0a6efwl">5 exclusive bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-165" data-mp="9b8npjdz0z9o">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-166" data-mp="3hphb8d1myzuz" />
              <span data-id="element-167" data-mp="3cp30uockbdts">Instant access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}